import { ButtonBase, CircularProgress } from "@material-ui/core";
import PageBox from "../../components/PageBox/PageBox.component";
import styles from "./Style.module.css";
import useHierarchyReport from "./HQReport.hook";
import TopBarFields from "./component/TopBarFields/TopBarFields.view";
import HQTable from "./component/HQTable/HQTable.view";
import TotalTable from "./component/TotalTable/TotalTable";

const labels = [
  { text: "HQ", color: "#f5f5f5", textColor: "#555" },
  // { text: "Active HQ Total", color: "#7168EF", textColor: "#fff" },
  { text: "State Total", color: "#2896E9", textColor: "#fff" },
  { text: "Zone Total", color: "#29CB97", textColor: "#fff" },
  {
    text: "Active Grand Total",
    color: "#2FA380",
    textColor: "#fff",
  },
  { text: "Closed HQ Total", color: "#F4881B", textColor: "#fff" },
  { text: "Inactive Grand Total", color: "#FE4B4B", textColor: "#fff" },
  { text: "Overall Total", color: "#E764CC", textColor: "#fff" },
];

const HQReport = ({ location }) => {
  const {
    isCalling,
    currentData,
    inActiveData,
    handleDownload,
    form,
    changeTextData,
    overAllTotal,
    downloading,
  } = useHierarchyReport({ location });

  return (
    <div>
      <PageBox>
        <div className={styles.headerContainer}>
          <div>
            <span className={styles.title}>HQ Wise Report</span>
            <div className={styles.newLine} />
          </div>
          <div className={styles.yearFlex}>
            <div className={styles.rightFlex}>
              <ButtonBase
                className={styles.download}
                onClick={handleDownload}
                disabled={downloading}
              >
                {downloading ? <CircularProgress size={20} /> : "DOWNLOAD"}
              </ButtonBase>
            </div>
          </div>
        </div>
        <br />
        <TopBarFields form={form} changeTextData={changeTextData} />
        <br />
        <div className={styles.containerBadge}>
          {labels.map((label, idx) => (
            <span
              key={idx}
              className={styles.badge}
              style={{ backgroundColor: label.color, color: label.textColor }}
            >
              {label.text}
            </span>
          ))}
        </div>
        <div className={styles.note}>Disclaimer: Regional classification before 1st April 2025 is not actual reflection of regions.</div>
      </PageBox>
      <br />
      <HQTable currentData={currentData} title={"Active HQ's"} />
      <br />
      <HQTable currentData={inActiveData} title={"Inactive HQ's"} />
      <br />
      <PageBox>
        <div className={styles.headerContainer}>
          <div>
            <span className={styles.title}>Overall Total</span>
            <div className={styles.newLine} />
          </div>
        </div>
        <br />
        <TotalTable overAllTotal={overAllTotal} />
        <br />
      </PageBox>
    </div>
  );
};

export default HQReport;
